import { string, shape } from 'prop-types';

export default shape({
    value: string.isRequired,
});
